import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import InputGroup from '../form/input-group';

class Component extends BaseComponent {
    render() {
        return (
            <forums-username>
                <row>
                    <column className='is-12'>
                        <InputGroup
                            label='Forums User Name'
                            type='text'
                            name='forum_name'
                            value={this.state.value || null}
                            placeholder=''
                            error={this.props.errors && this.props.errors.forum_name}
                            onInput={this.handleChange}
                        />
                    </column>
                </row>
            </forums-username>
        );
    }

    handleChange = (e) => {
        this.setState({
            value: e.target.value,
        });

        this.props.onChange(e.target.name, e.target.value);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    errors: state.settings && state.settings.errors || {},
});

export default connect(mapStateToProps)(Component);
